/**
 * Determines the environment based on the current domain.
 * Returns 'stage' for localhost or domains containing 'stage', otherwise 'prod'.
 */
export const getEnvironmentFromUrl = (): 'stage' | 'prod' => {
    const hostname = window.location.hostname

    if (hostname === 'localhost' || hostname.includes('stage')) {
        return 'stage'
    }

    return 'prod'
}
